import { MapPin } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { CITIES } from "@/pages/CitiesData";

export default function MetropoleSection() {
  return (
    <section
      data-testid="metropole-section"
      className="border-y border-white/5 bg-surface/40 px-5 py-16 md:px-8 md:py-24"
    >
      <div className="mx-auto max-w-7xl">
        <SectionHeading
          eyebrow="Zones d'intervention"
          title="Vos états des lieux dans toute la Métropole de Lyon"
          subtitle="Entrées et sorties numériques avec photos, rapports détaillés réalisés sous ImmoPad — pour les agences immobilières, administrateurs de biens, propriétaires et conciergeries. EDL-EXPRESS se déplace directement dans les logements : nous n'avons pas d'agence dans ces communes, notre équipe itinérante part de Bron."
        />
        <div className="mt-10 flex flex-wrap gap-3">
          {CITIES.map((c, i) => (
            <Reveal key={c.slug} delay={i * 0.05}>
              <a
                href={`/etat-des-lieux-${c.slug}`}
                data-testid={`metropole-city-${c.slug}`}
                className="inline-flex items-center gap-2 rounded-full border border-cyan-400/30 bg-cyan-400/5 px-5 py-2.5 text-sm font-medium text-cyan-300 transition-colors hover:border-cyan-400/60 hover:bg-cyan-400/15"
              >
                <MapPin className="h-4 w-4" /> {c.name}
              </a>
            </Reveal>
          ))}
        </div>
        <p className="mt-8 text-sm leading-relaxed text-slate-400">
          EDL Express intervient à Lyon, Villeurbanne, Bron, Vaulx-en-Velin, Vénissieux,
          Caluire-et-Cuire, Décines-Charpieu, Meyzieu, Saint-Priest, Oullins-Pierre-Bénite et
          dans toute la Métropole de Lyon.
        </p>
        <p className="mt-4 text-sm leading-relaxed text-slate-400">
          Déplacement inclus dans un rayon de 10 km autour de Bron ; au-delà, +0,80 €/km
          aller-retour avec un minimum de 15 €. Les kilomètres facturables au-delà de la zone
          incluse sont calculés selon une méthode explicite, communiquée avant validation.
          Pour les interventions plus éloignées, une étude ou un devis reste possible
          (au-delà de 35 km : sur devis).
        </p>
      </div>
    </section>
  );
}
